export function storeInCache(key, data, ttlInSeconds) {
    try {
      const currentTime = new Date().getTime();
      const expirationTime = currentTime + ttlInSeconds * 1000; 
  
      const cacheObject = {
        data,
        expirationTime,
      };
  
      localStorage.setItem(key, JSON.stringify(cacheObject));
    } catch (error) {
      console.error('Error storing data in cache:', error);
    }
  }
  
  export function getFromCache(key) {
    try {
      const cachedData = localStorage.getItem(key);
      if (!cachedData) {
        return null;
      }
  
      const cacheObject = JSON.parse(cachedData);
      const currentTime = new Date().getTime();
  
      if (currentTime <= cacheObject.expirationTime) {
        return cacheObject.data;
      } else {
        localStorage.removeItem(key);
        return null;
      }
    } catch (error) {
      console.error('Error retrieving data from cache:', error);
      return null;
    }
  }
  